import { Link } from "react-router";

interface EditorButtonProps {
    src: string;
    label: string;
    to?: string;
    onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void
}

export function EditorButton({ src, label, to, onClick }: EditorButtonProps) {
    return <Link to={to || ""} onClick={onClick} className='group mr-3'>
        <img src={src} className='w-8 inline-block pr-1 group-hover:saturate-0' alt="editor icon" />
        <span className='align-middle group-hover:font-semibold'>{label}</span>
    </Link>
}